import { Affix, Button, Card, Spin } from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getData, postData } from "../../../apiServices/common";
import { isArrayAndHasValue } from "../../../utils/functions";
import { isMobileView } from "../../Common/AppHelper";
import Header from "../../Common/Header";
import AddPurchaseOrderForm from "./AddUnitsPriceForm";

export default function ViewPOWiseBreakdown(props) {
  // Props
  const { width } = props;

  // Router
  let { styleId } = useParams();
  const navigate = useNavigate();

  // States
  const [permitInfo, setPermitInfo] = useState();
  const [poDetailsData, setPoDetailsData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Others
  const propertyFormRef = useRef(null);
  const edit_url = `/api/unit_prices/${styleId}/edit`;

  const discartForm = () => {
    navigate("/merchandising/po-wise-purchase-order-breakdown");
  };

  const getPOInfo = useCallback(async () => {
    let res = await postData(edit_url);

    if (res && res?.code === 200) {
      let masterData = res.data;
      setPermitInfo(masterData);
      const po_data = masterData ? masterData.unit_price_details : null;

      const po_details =
        isArrayAndHasValue(po_data) &&
        po_data.map((item) => {
          const sizes = {};

          item?.sizes?.forEach((size) => {
            sizes[size?.name + "_" + size?.id] = size?.sales_order_quantity;
          });
          return {
            ...item,
            style_id: item.style?.id,
            color_id: item.color?.id,
            ...sizes,
          };
        });

      setPoDetailsData(po_details || []);
    }
    setIsLoading(false);
  }, [edit_url]);

  useEffect(() => {
    getPOInfo();
  }, [getPOInfo]);

  return (
    <>
      <Affix offsetTop={0}>
        <Card className="p-fixed" style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}>
          <Header
            title="View PO Breakdown"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button size="small" key={1} danger onClick={() => discartForm()}>
                Back
              </Button>,
            ]}
          ></Header>
        </Card>
      </Affix>

      <Spin spinning={isLoading} tip="Loading...">
        <AddPurchaseOrderForm
          ref={propertyFormRef}
          permitInfo={permitInfo}
          view={true}
          poDetailsData={poDetailsData}
          setPoDetailsData={setPoDetailsData}
          mode={"view"}
        />
      </Spin>
    </>
  );
}
